<template>
  <v-dialog v-model="value" max-width="640" persistent>
    <template #activator="{on, attr}">
      <v-btn v-if="withButton" text color="error" v-on="on" v-bind="attr">
        <span v-if="textButton">
          {{ textButton }}
        </span>
        <v-icon v-else color="error">
          mdi-delete-forever
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text class="pt-4 pb-0">
        <v-alert outlined type="error" prominent>
          {{ message }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn text color="primary" @click="closeDialog">Отмена</v-btn>
        <v-btn text color="red" @click="deleteUser">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeletingDialog",

  data() {
    return {};
  },

  props: {
    data: Object,
    title: { type: String, default: () => "Удаление" },
    textButton: { type: String, default: () => null },
    message: { type: String, default: () => "" },
    withButton: { type: Boolean, default: () => true },
    value: { type: Boolean, default: () => false }
  },

  methods: {
    closeDialog() {
      return (this.value = false);
    },

    deleteUser() {
      this.$emit("delete-request", this.data);
      this.closeDialog();
    }
  }
};
</script>
